import camelCase from 'lodash/camelCase';

import transformAccessRulesToModel from '../helpers/transformAccessRulesToModel';
import useGlobalQueries from './useGlobalQueries';

export default (classType) => {
  const { currentUser } = useGlobalQueries();
  const isUnrestrictedAdmin = Boolean(currentUser.data?.authority === 'superadmin');

  const rules = currentUser.data?.access_rules;
  const model = rules && transformAccessRulesToModel(rules);
  const access = model?.[camelCase(classType)]?.access;
  const enforcementRule = model?.[camelCase(classType)]?.enforcement_rule;

  return {
    access,
    enforcementRule,
    isLoading: currentUser.isLoading,
    isUnrestrictedAdmin,
  };
};
